import React, { useContext, useState } from "react";
import { FaCheck, FaCheckCircle, FaPlus, FaTrashAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { httpReauest } from "../../../utils/httpRequest";
import { BASE_URL, CDN_BASE_URL } from "../../../config";
import { AuthContext } from "../../../context/AuthContext";

const VideoUpload = ({ data, stayLogin }) => {
  const [img2, setImg2] = useState();
  const [previewImg2, setPreviewImg2] = useState();

  function handleImg2(e) {
    const fils = e.target.files[0];

    setImg2(fils);
    setPreviwImage2(fils);
  }

  async function setPreviwImage2(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg2(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  const { user, setUser } = useContext(AuthContext);

  async function handleUpdate() {
    const formdata = new FormData();

    formdata.append("video", img2);
    formdata.append("id", data?._id);

    await fetch(BASE_URL + "/blog/file/video", {
      method: "PUT",
      body: formdata,
      headers: { "x-access-token": user.token },
    }).then(({ status }) => {
      if (status === 201) {
        toast.success("موفقیت آمیز بود");
        stayLogin();
      }
    });
  }

  async function handleDelete() {
    await fetch(BASE_URL + "/blog/file/" + data?._id, {
      method: "DELETE",
      headers: { "x-access-token": user.token },
    }).then(({ status }) => {
      if (status === 201) {
        toast.success("موفقیت آمیز بود");
        stayLogin();
      }
    });
  }

  return (
    <>
      <input
        onChange={(e) => {
          handleImg2(e);
        }}
        type="file"
        className="hidden"
        id={data?._id}
        accept="video/mp4,video/x-m4v,video/*"
      />
      <label
        htmlFor={data?.file ? "" : data?._id}
        className="relative w-full border-dashed border rounded-[10px] p-3 h-[200px] cursor-pointer border-[#444] "
      >
        {data?.file ? (
          <video
            src={CDN_BASE_URL + data?.file}
            className="w-full h-full object-contain"
            alt=""
            autoPlay
            loop
            muted
          />
        ) : previewImg2 ? (
          <video
            src={previewImg2}
            className="w-full h-full object-contain"
            alt=""
            autoPlay
            loop
            muted
          />
        ) : (
          <FaPlus className="center" size={30} />
        )}

        <p className="on-border font-bold">ویدیو</p>
        {!data?.file && previewImg2 && (
          <button
            onClick={handleUpdate}
            className="mt-5 z-10 w-full flex justify-center"
          >
            <FaCheckCircle color="green" size={30} />
          </button>
        )}

        {data?.file && (
          <button
            onClick={handleDelete}
            className="mt-5 z-10 w-full flex justify-center"
          >
            <FaTrashAlt color="red" size={30} />
          </button>
        )}
      </label>
    </>
  );
};

export default VideoUpload;
